/* eslint-disable func-names */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState, useEffect } from 'react';
import { includes } from 'lodash';
import { Link, navigate } from 'gatsby';
import { getTranslationByKey } from '../helpers/translation-helper';
import { Header } from './styles/Header.styled';
import { Nav, Primary, PrimaryNavDesktop, PrimaryNavMobile } from './styles/NavPrimary.styled';
import { MenuItem } from './styles/MenuItem.styled';
import { MenuItemLink } from './styles/MenuItemLink.styled';
import { GlobalLink } from './styles/GlobalLink.styled';
import { LangLink } from './styles/LangLink.styled';
import { Logo } from './styles/Logo.styled';
import {
  SearchContainer,
  SearchMobileMenu,
  MenuCloseButton,
  MobileMenuCloseButton,
} from './styles/SearchContainer.styled';

import { NavGlobal, Meta } from './styles/NavGlobal.styled';

import {
  NavToggle,
  Secondary,
  Wrapper,
  SecondaryContainer,
  SecondaryLinkUl,
  Submenu,
  SubmenuLink,
} from './styles/NavSecondary.styled';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';
import MenuButton from './MenuButton';

export default function Topbar({ settings, currentPage, lang, dir, isHome, currentClass }) {
  const [searchActive, toggleSearch] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const ref = useRef();
  let selectedFound = false;
  useEffect(() => {
    const cachedRef = ref.current;
    const observer = new IntersectionObserver(([e]) => setIsSticky(e.intersectionRatio < 1), {
      threshold: [1],
    });

    observer.observe(cachedRef);

    // unmount
    return function () {
      observer.unobserve(cachedRef);
    };
  }, []);

  const handleToggle = () => {
    toggleSearch(!searchActive);
  };

  const [toggleNav, setToggleNav] = useState(false);
  const handleNav = () => {
    setToggleNav(!toggleNav);
  };

  const [activeButton, setActiveButton] = useState(false);

  const isSelected = (udi) => {
    let selected = [];
    settings.mainNavigation.forEach((item) => {
      if (item.content.link) {
        if (item.content.link.udi === currentPage.udi) {
          selected = [item.content.link.udi];
        }
        if (item.content.itemChildren) {
          item.content.itemChildren.forEach((child) => {
            if (child.content.link && child.content.link.udi === currentPage.udi) {
              selected = [item.content.link.udi, child.content.link.udi];
            }
            if (child.content.itemChildren) {
              child.content.itemChildren.forEach((child1) => {
                if (child1.content.link && child1.content.link.udi === currentPage.udi) {
                  selected = [
                    item.content.link.udi,
                    child.content.link.udi,
                    child1.content.link.udi,
                  ];
                }
              });
            }
          });
        }
      }
    });
    return selected.indexOf(udi) > -1;
  };
  const { cssClass } = React.useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return '#ce445b';
    if (includes(cssClass, 'real-estate')) return '#1ba39c';
    if (includes(cssClass, 'about-us-page')) return '#575757';
    return '#1b7bdd';
  };

  const getWebsite = () => {
    if (includes(cssClass, 'free-zone')) return 'free-zone';
    if (includes(cssClass, 'about-us-page')) return 'about-us-page';
    return 'main';
  };

  const hasNoChildren = () =>
    includes(cssClass, 'free-zone') ||
    includes(cssClass, 'about-us-page') ||
    includes(cssClass, 'real-estate');

  const handleColor = (index, content) => {
    if (isSelected(content.link.udi)) return `#${content.color}`;
    if (includes(cssClass, 'events') && !index) return '#1b7bdd';
    return '';
  };

  const searchLabel = dir === 'rtl' ? 'ابدأ البحث...' : 'Start your search here…';

  useEffect(() => {
    const classes = currentClass ? currentClass.split(' ').filter(Boolean) : [];

    if (classes.length > 0) {
      classes.forEach((className) => document.body.classList.add(className));
    }

    return () => {
      if (classes.length > 0) {
        classes.forEach((className) => document.body.classList.remove(className));
      }
    };
  }, [currentClass]);

  const { translations } = React.useContext(DWTCContext);

  const titles = {
    'free-zone': 'Free Zone',
    events: 'Events',
    'real-estate': 'Real Estate',
  };

  const matchingKey = cssClass && Object.keys(titles).find((key) => cssClass.includes(key));
  const menuTitle = matchingKey ? titles[matchingKey] : 'About Us';

  // Update the handleToggleSubmenu function
  const handleToggleSubmenu = (name) => {
    setActiveButton((prevActiveButton) => (prevActiveButton === name ? false : name));
  };

  const renderSubmenu = (item, index) => (
    <>
      <p className="menu-title uppercase">{`${getTranslationByKey(translations, menuTitle)}`}</p>
      <SecondaryLinkUl className="sec-link" dir={dir} key={index}>
        {item.content.itemChildren &&
          item.content.itemChildren.map((child, childIndex) => (
            <MenuButton
              key={childIndex}
              className={`${
                isSelected(child.content.link.udi)
                  ? `${
                      child?.content?.itemChildren?.length > 0 ? 'activemenu' : ''
                    } ${hasNoChildren() ? 'no-child' : ''}`
                  : `${hasNoChildren() ? 'no-child' : ''}`
                }
                ${
                  child?.content?.itemChildren?.length > 0
                    ? 'has-submenu title-has-children'
                    : 'title-has-no-children'
                }
                ${activeButton === child.content.link.name ? 'activemenu' : ''}
                `}
              dir={dir}
              position={child.content.innerTitle}
              color={handleColor(index, item.content)}
              hover={`#${item.content.color}`}>
              <Link
                className={`${cssClass} menua-link`}
                to={child.content.link.url}
                target="_self"
                title={child.content.link.name}
                role="menuitem"
                color={handleColor(index, item.content)}
                hover={handleColor(index, item.content)}
                dir={dir}
                onClick={handleNav}>
                {child.content.link.name} <small>{child.content.subtitle}</small>
              </Link>
  
              <i
                onClick={() => handleToggleSubmenu(child.content.link.name)}
                className="togl_icn-sz"
                dir={dir}
              />
              {child?.content?.itemChildren?.length > 0 ? (
                <div
                  className={`${
                    child?.content?.itemChildren?.length > 0
                      ? 'menu-has-children'
                      : 'menu-has-no-children'
                  }`}>
                  {child.content.itemChildren && child.content.itemChildren.length > 0 ? (
                    <Submenu
                      className={`${
                        activeButton === child.content.link.name
                          ? 'third-level-menu show'
                          : 'third-level-menu'
                      }
                  `}
                      dir={dir}>
                      {child.content.itemChildren.map(
                        (ter, index1) =>
                          ter.content.link && (
                            <SubmenuLink
                              to={ter.content.link ? ter.content.link.url : '#0'}
                              className={isSelected(ter.content.link.udi) ? 'active' : ''}
                              target="_self"
                              title={ter.content.link.name}
                              role="menuitem"
                              key={index1}
                              dir={dir}>
                              {ter.content.link.name}
                            </SubmenuLink>
                          ),
                      )}
                    </Submenu>
                  ) : null}
                </div>
              ) : (
                ''
              )}
            </MenuButton>
          ))}
      </SecondaryLinkUl>
    </>
  );

  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handelKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      navigate(`/${lang}/search/?q=${e.target.value}`);
    }
  };

  const handelSearch = (e) => {
    e.preventDefault();
    navigate(`/${lang}/search/?q=${searchTerm}`);
  };
  const primaryItems = settings.mainNavigation.slice(0, 3).map((item, indexP) => (
    <MenuItem
      key={indexP}
      color={handleColor(indexP, item.content)}
      hover={`#${item.content.color}`}
      dir={dir}>
      <MenuItemLink
        key={item.content.link.id}
        target="_self"
        to={item.content.link.url}
        title={item.content.link.name}
        dir={dir}
        className="primary_menu">
        {item.content.link.name}
      </MenuItemLink>
    </MenuItem>
  ));

  const metaItem = settings.mainNavigation.slice(-1).map((item, indexM) => (
    <MenuItem
      key={indexM}
      color={handleColor(indexM, item.content)}
      hover={`#${item.content.color}`}
      dir={dir}
      className="about-li">
      <MenuItemLink
        key={item.content.link.id}
        target="_self"
        to={item.content.link.url}
        title={item.content.link.name}
        dir={dir}
        className={`primary_menu about_menu ${currentClass === 'about-us-page' ? 'active' : ''}`}>
        {item.content.link.name}
      </MenuItemLink>
    </MenuItem>
  ));

  return (
    <Header id="topbar-header" className={isSticky ? 'isSticky' : ''} ref={ref} dir={dir}>
      <Nav className={toggleNav ? 'navbg' : ''} dir={dir}>
        <Primary className="primary" dir={dir}>
          <PrimaryNavDesktop>{primaryItems}</PrimaryNavDesktop>
          <PrimaryNavMobile>
            {settings.mainNavigation.map((item, indexN) => (
              <MenuItem
                key={indexN}
                color={handleColor(indexN, item.content)}
                hover={`#${item.content.color}`}
                dir={dir}>
                <MenuItemLink
                  key={item.content.link.id}
                  target="_self"
                  to={item.content.link.url}
                  title={item.content.link.name}
                  dir={dir}
                  className={`primary_menu ${currentClass === 'about-us-page' ? 'active about-nav' : ''}`}>
                  {item.content.link.name}
                </MenuItemLink>
              </MenuItem>
            ))}
          </PrimaryNavMobile>
        </Primary>

        <NavGlobal>
          <Meta role="menu" aria-label="Global Menu">
            {metaItem}
            {settings.links.map((item, indexMI) => (
              // console.log(item);
              <GlobalLink
                key={`${indexMI}_GlobalLink`}
                to={item.url}
                className={item.url === currentPage.url ? 'is-selected' : ''}
                target={item.target}
                title={item.name}
                role="menuitem"
                dir={dir}>
                {item.name}
              </GlobalLink>
            ))}
          </Meta>

          <LangLink
            to={
              lang === 'en'
                ? currentPage.url.replace('/en/', '/ar/')
                : currentPage.url.replace('/ar/', '/en/')
            }
            aria-label="Change Language"
            dir={dir}
            className={`lang ${isHome ? '' : 'sec-lang ins_lang'}`}>
            <i className="sr-only">Language</i>
          </LangLink>

          <SearchContainer role="search" className={searchActive ? 'sb-search-open' : ''} dir={dir}>
            <button
              type="button"
              aria-label="Search"
              className="sb-icon-search"
              onClick={handleToggle}>
              <Sprites name="search" />
            </button>
            <input
              className="sb-search-input"
              placeholder={searchLabel}
              data-results-page="/en/search"
              type="text"
              defaultValue=""
              name="search"
              aria-label={searchLabel}
              autoComplete="off"
              onKeyDown={handelKeyDown}
              onChange={handleChange}
            />
            <button
              type="submit"
              className="sb-search-submit"
              onClick={handelSearch}
              data-results-page="/en/search">
              <span className="sr-only">Search</span>
            </button>
          </SearchContainer>
        </NavGlobal>

        <Secondary
          id="secondary-navbar"
          className={`secondary ${isHome ? '' : 'fix secondary-page-nav'}`}
          dir={dir}
          color={getTheme()}>
          <Logo to={`/${lang}`} aria-label="Logo" className={`logo ${getWebsite()}`} dir={dir}>
            <i className={`dwtclogo ${getWebsite()}`} dir={dir} />
          </Logo>

          <NavToggle
            className={`toggleBtn ${getWebsite()}`}
            onClick={handleNav}
            to="#"
            role="button"
            aria-label="Toggle Button"
            tabIndex="-1">
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </NavToggle>

          <Wrapper className={toggleNav ? 's-menu show' : 's-menu'} dir={dir}>
            <LangLink
              to={
                lang === 'en'
                  ? currentPage.url.replace('/en/', '/ar/')
                  : currentPage.url.replace('/ar/', '/en/')
              }
              aria-label="Change Language"
              dir={dir}
              className="mbl_lang">
              <i className="sr-only">Language</i>
            </LangLink>
            <SecondaryContainer className="sec-menu active" dir={dir}>
              <SearchMobileMenu role="search" className="sb-search-open mbl_search" dir={dir}>
                <button
                  type="button"
                  aria-label="Search"
                  className="sb-icon-search"
                  onClick={handelSearch}>
                  <Sprites name="search" />
                </button>
                <input
                  className="sb-search-input"
                  placeholder={searchLabel}
                  data-results-page="/en/search"
                  type="text"
                  onChange={handleChange}
                  onKeyDown={handelKeyDown}
                  defaultValue=""
                  name="search"
                  aria-label={searchLabel}
                  autoComplete="off"
                />
                <button
                  type="submit"
                  className="sb-search-submit"
                  data-results-page="/en/search"
                  onClick={handleToggle}>
                  <span className="sr-only">Search</span>
                </button>
              </SearchMobileMenu>
              {settings.mainNavigation.map((item, indexMN) => {
                if (isSelected(item.content.link.udi)) {
                  selectedFound = true;
                  return renderSubmenu(item, indexMN);
                }
                return null;
              })}
              {!selectedFound && renderSubmenu(settings.mainNavigation[0], 0)}
              <MenuCloseButton onClick={() => setIsSticky(false)} dir={dir} />
              <MobileMenuCloseButton onClick={() => setToggleNav(false)} dir={dir} />
              <Meta role="menu" aria-label="Global Menu" className="meta_mbl_menu">
                {settings.links.map((item, indexGI) => (
                  <GlobalLink
                    key={`${indexGI}_meta_mbl_menu`}
                    to={item.url}
                    className={item.url === currentPage.url ? 'is-selected' : ''}
                    target={item.target}
                    title={item.name}
                    role="menuitem"
                    dir={dir}>
                    {item.name}
                  </GlobalLink>
                ))}
              </Meta>
            </SecondaryContainer>
          </Wrapper>
        </Secondary>
      </Nav>
    </Header>
  );
}
